module.exports = __webpack_public_path__ + "static/media/web-bg.55184806.png";